.root {
  display: flex;
  width: fit-content;
  max-width: 100%;
  align-items: center;
  gap: 0.25rem;
  padding-block: 0.25rem;
  padding-inline: 0.625rem 0.25rem;
  border-radius: var(--radius-md);
  background: var(--color-background-2);
  color: var(--color-inline-code-foreground);
  overflow: hidden;
}

.root:not(:has(.copyButton)) {
  padding-inline-end: 0.625rem;
}

.root[data-variant="field"] {
  width: 100%;
  padding: 0.5rem 0.75rem;
  border-radius: var(--radius-lg);
}

.scroller {
  min-width: 0;
  flex: 1;
  overflow-x: auto;
  scrollbar-width: thin;
  scrollbar-color: color-mix(in srgb, var(--color-muted) 40%, transparent) transparent;
  cursor: text;
  user-select: all;

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: color-mix(in srgb, var(--color-muted) 40%, transparent);
    border: 0;
  }
}

.content {
  display: block;
  padding-block: 0.25rem;
  color: inherit;
  font-size: 0.8125rem;
  white-space: nowrap;
}

.copyButton {
  flex-shrink: 0;
  color: var(--color-muted) !important;
  user-select: none;
}

.root[data-truncate="true"] {
  .scroller {
    overflow-x: hidden;
  }

  .content > :global([data-link]) {
    display: inline;
  }
}
